import { YesNoButtons } from "./YesNoButtons";
import { Field, FieldArray } from "formik";
import { SimpleSingleSelect } from "./SimpleSingleSelect";
import { AddAdditional, CurrencyInputField, LabelledCheckbox } from "@coverme/forms";
import { DateInput } from "./DateInput";
import React from "react";

export const AssetQuestionField = ({
    values,
    getErrors,
    getValidationState,
    thePatient,
    setFieldValue,
    setFieldTouched,
    assetTypes,
    isRequired,
    ...props
}) => (
    <>
        <div className="form-section">
            <div className="form-control">
                <YesNoButtons
                    {...props}
                    name={"hasAssets"}
                    title={`Does ${thePatient} own any major assets?`}
                    setFieldValue={setFieldValue}
                    getErrors={getErrors}
                    isRequired={isRequired}
                    getValidationState={getValidationState}
                />
            </div>
        </div>
        {values.hasAssets && (
            <FieldArray
                name={"assets"}
                render={arrayHelpers => (
                    <div className="form-section">
                        {values.assets.map((e, i) => (
                            <div key={i} className="form-card">
                                <div className="form-control m-input">
                                    <Field
                                        name={`assets.${i}.type`}
                                        render={({ field }) => (
                                            <SimpleSingleSelect
                                                {...field}
                                                id={`assets.${i}.type`}
                                                title={"Asset Type"}
                                                autoFocus={true}
                                                setFieldTouched={setFieldTouched}
                                                setFieldValue={setFieldValue}
                                                errorMessage={getErrors(field)}
                                                required={isRequired(field)}
                                                validState={getValidationState(field)}
                                                options={assetTypes}
                                            />
                                        )}
                                    />
                                </div>
                                <div className="form-control m-input">
                                    <Field
                                        name={`assets.${i}.value`}
                                        render={({ field }) => (
                                            <CurrencyInputField
                                                id={`assets.${i}.value`}
                                                value={field.value}
                                                changeEvent={e => {
                                                    setFieldValue(`assets.${i}.value`, e);
                                                }}
                                                errorMessage={getErrors(field)}
                                                required={isRequired(field)}
                                                validState={getValidationState(field)}
                                                {...field}
                                                title={`Asset Value`}
                                            />
                                        )}
                                    />
                                </div>
                                <div className="form-control m-input">
                                    <Field
                                        name={`assets.${i}.jointlyOwned`}
                                        render={({ field }) => (
                                            <LabelledCheckbox
                                                {...field}
                                                id={field.name}
                                                groupName={field.name}
                                                value={field.name}
                                                required={isRequired(field)}
                                                labelText={"Jointly Owned"}
                                                checked={field.value === true}
                                            />
                                        )}
                                    />
                                </div>
                                <div
                                    className="card-remove"
                                    onClick={() => {
                                        arrayHelpers.remove(i);
                                    }}
                                >
                                    <svg
                                        width="14px"
                                        height="18px"
                                        viewBox="0 0 18 22"
                                        version="1.1"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <g
                                            id="Form-(Approved)"
                                            stroke="none"
                                            strokeWidth="1"
                                            fill="none"
                                            fillRule="evenodd"
                                        >
                                            <g
                                                id="CM---Form---Filled"
                                                transform="translate(-1253.000000, -5124.000000)"
                                                fill="#EC3C62"
                                            >
                                                <g id="Financial" transform="translate(504.000000, 3136.000000)">
                                                    <g id="Expenses" transform="translate(0.000000, 1863.000000)">
                                                        <g id="4" transform="translate(0.000000, 111.000000)">
                                                            <path
                                                                d="M750.222222,33.5555556 C750.222222,34.9 751.322222,36 752.666667,36 L762.444444,36 C763.788889,36 764.888889,34.9 764.888889,33.5555556 L764.888889,18.8888889 L750.222222,18.8888889 L750.222222,33.5555556 L750.222222,33.5555556 Z M766.111111,15.2222222 L761.833333,15.2222222 L760.611111,14 L754.5,14 L753.277778,15.2222222 L749,15.2222222 L749,17.6666667 L766.111111,17.6666667 L766.111111,15.2222222 L766.111111,15.2222222 Z"
                                                                id="icon:trash"
                                                            />
                                                        </g>
                                                    </g>
                                                </g>
                                            </g>
                                        </g>
                                    </svg>
                                </div>
                            </div>
                        ))}
                        <div style={{ width: "fit-content" }}>
                        <AddAdditional
                            labelText="Add additional asset"
                            clickEvent={() =>
                                arrayHelpers.push({
                                    type: "",
                                    value: "",
                                    jointlyOwned: "",
                                    dateEstablished: "",
                                })
                            }
                        />
                        </div>
                    </div>
                )}
            />
        )}
    </>
);
